<img *ngIf="imgUrl" [src]="imgUrl" />
<span class="title">{{ title }}</span>
<span class="subtitle">{{ subtitle }}</span>
<app-button size="lg" (click)="onButtonClick()">{{ getButtonText() }}</app-button>
